import React from 'react';
import { AdminHeader, AdminSidebar } from 'components';
import { PublicHolidayUploadForm } from 'components/organisms/PublicHolidayUploadForm';

export const PublicHolidayUpload = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <PublicHolidayUploadForm />
      </div>
    </>
  );
};
